const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/integrations/ukg.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/integrations/ukg")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "UKG Integration",
      description: "Page title for the ukg integration page"
    })
  }
});